module.exports = __webpack_public_path__ + "static/003-d084dc5b6ee42b9608abf9fbe41806c8.png";